// Flags for enabling/disabling features
export const testConnectSidebarEnabled = false;
export const suggestedProductsEnabled = false;
export const integrationsTabEnabled = false;
